import { POSTS } from "../configs/routes.js";
import api from "./api.js";

export const getPosts = (params = {}) =>
    new Promise((resolve, reject) => {
        api
            .get(POSTS, { params, timeout: 60000 })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
    });
